import { jsx as _jsx } from "react/jsx-runtime";
import { faFile, faFileCode, faFileImage, faFilePdf, faFileText, faFileVideo, faFileZip } from "@fortawesome/pro-regular-svg-icons";
import ReloadingBox from "../lazy/ReloadingBox.js";
import ThumbnailBox from "./box/ThumbnailBox.js";
import ThumbnailLoading from "./ThumbnailLoading.js";
// Media settings.
export const EMBED_TYPES = ["application/pdf", "video/mp4", "video/webm", "video/mpeg"];
export const IMAGE_TYPES = {
    "image/png": [".png"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/webp": [".webp"],
};
export const VIDEO_TYPES = {
    "video/mp4": [".mp4"],
    "video/webm": [".webm"],
    "video/mpeg": [".mpg", ".mpeg"],
};
export function isLightBoxType(type) {
    return [...Object.keys(IMAGE_TYPES), ...EMBED_TYPES].includes(type);
}
// Icons
export function fileIcon(type) {
    if (type === "application/pdf") {
        return { icon: faFilePdf };
    }
    else if (type === "text/plain") {
        return { icon: faFileText };
    }
    else if (type === "text/html" || type === "application/json") {
        return { icon: faFileCode };
    }
    else if (type === "application/gzip" || type === "application/zip") {
        return { icon: faFileZip };
    }
    else if (type.startsWith("image/")) {
        return { icon: faFileImage };
    }
    else if (type.startsWith("video/")) {
        return { icon: faFileVideo };
    }
    else {
        return { icon: faFile };
    }
}
export const JSON_MEDIA_TYPE = {
    singular: "JSON",
    plural: "JSON",
    accept: {
        "application/json": [".json"],
    }
};
export const ICON_MEDIA_TYPE = {
    singular: "Icon",
    plural: "Icons",
    accept: IMAGE_TYPES
};
export const PHOTO_MEDIA_TYPE = {
    singular: "Photo",
    plural: "Photos",
    accept: IMAGE_TYPES,
    showCamera: true
};
export const VIDEO_MEDIA_TYPE = {
    singular: "Video",
    plural: "Videos",
    accept: VIDEO_TYPES
};
export const ALL_MEDIA_TYPE = {
    singular: "Media",
    plural: "Media",
    showCamera: true,
};
export function thumbnailLazy(options) {
    return {
        onLoading: () => _jsx(ThumbnailBox, { ...options, children: _jsx(ThumbnailLoading, { text: "Loading..." }) }),
        onReloading: props => _jsx(ReloadingBox, { ...props })
    };
}
